import React from "react";
import { Container } from "./container";
import { LimaImage, getImageDataOrPublicURL } from "./lima-image";
import { IntroText } from "./blocks/intro-text";

export const ArticleHeader: React.FC<{
  title?: string | null;
  video?: string | null;
  image?: ImageDataLikeWithPropsForGifs | null;
  eventInfo?: {
    startDate?: string | null;
    endDate?: string | null;
    startTime?: string | null;
    endTime?: string | null;
    location?: string | null;
    ticketLabel?: string | null;
    ticketURL?: string | null;
  } | null;
  introduction: (React.JSX.Element | null)[] | null;
  summary?: string | null;
  author: {
    readonly name: string | null;
    readonly slug: string | null;
  } | null;
}> = ({ title, video, image, eventInfo, introduction, author, summary }) => {
  const imageData = image ? getImageDataOrPublicURL(image) : null;
  return (
    <>
      <Container className="grid grid-cols-4 gap-16 lg:-mt-36">
        <div className="col-span-4 lg:col-span-3">
          {imageData && !video && <LimaImage image={imageData} alt="" />}
          {video && (
            <video src={video} className="w-full" muted loop autoPlay />
          )}
        </div>
      </Container>
      <Container className="mt-8 grid grid-cols-4 gap-16 lg:mt-16">
        <div className="hidden lg:block" />
        <h1 className="col-span-4 text-lg font-bold leading-none lg:col-span-2 lg:text-3xl">
          {title || ""}
        </h1>
      </Container>
      {summary && (
        <Container className="mt-8 grid grid-cols-4 gap-16 lg:mt-6">
          <div className="hidden lg:block" />
          <h1 className="col-span-4 text-lg leading-none lg:col-span-2 lg:text-2xl">
            {summary || ""}
          </h1>
        </Container>
      )}
      {eventInfo && (
        <>
          <Container className="mt-4 grid grid-cols-4 gap-16 lg:mt-5">
            <div className="hidden lg:block" />
            <div className="col-span-4 font-serif text-base leading-none lg:col-span-2 lg:text-2xl">
              <span>
                {eventInfo.startDate}
                {eventInfo.endDate && ` - ${eventInfo.endDate}`}
              </span>
              {eventInfo.startTime && (
                <span className="">
                  {" "}
                  {eventInfo.startTime.split(":")[0]}:
                  {eventInfo.startTime.split(":")[1]}
                  {eventInfo.endTime &&
                    ` - ${eventInfo.endTime.split(":")[0]}:${
                      eventInfo.endTime.split(":")[1]
                    }`}
                </span>
              )}
            </div>
          </Container>
          <Container className="mt-2 grid grid-cols-4 gap-16 lg:mt-5">
            <div className="hidden lg:block" />
            <div className="text-md col-span-4 font-bold leading-none lg:col-span-2 lg:text-base">
              {eventInfo.location}
            </div>
          </Container>
          <Container className="mt-3 grid grid-cols-4 gap-16 lg:mt-5">
            <div className="hidden lg:block" />
            <div className="col-span-4 lg:col-span-2 ">
              <a
                className="text-md relative -left-1 rounded-lg border border-beige bg-white px-3 py-1 font-bold lg:rounded-2xl lg:px-10 lg:py-2 lg:text-lg"
                href={eventInfo.ticketURL || "#"}
                target="_blank"
              >
                {eventInfo.ticketLabel}
              </a>
            </div>
          </Container>
        </>
      )}
      {introduction && <IntroText>{introduction}</IntroText>}
    </>
  );
};
